import { Component, OnInit } from '@angular/core';
import { AuthentificationService } from '../services/authentification.service';
import { Router } from '@angular/router';
import { TokenStorage } from '../../core/token.storage';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { CheckTokenService } from '../../common/services/check-token.service';


@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.css']
})
export class AuthComponent implements OnInit {
constructor(private checkTokenService: CheckTokenService, private router: Router, private token: TokenStorage, private authService: AuthentificationService, private toastr: ToastrService) {
         if (this.token.getToken() != null) {
           
            this.router.navigate(['main']); 
           
        }

 }
  login: string;
  password: string;
  loginForm: FormGroup;

    ngOnInit() {
        this.createForm();
    }

    private createForm() {
        this.loginForm = new FormGroup({
            // tslint:disable-next-line
            login: new FormControl('', [Validators.required, Validators.pattern('')]),
            password: new FormControl('', Validators.required),
        });
    }

    loginUp(): void {
        this.authService.attemptAuth(this.login, this.password).subscribe(
            (data) => {
                if(data.admin === false){
                    this.token.saveToken(data.token);
                    this.token.saveLogin(this.login);
                    this.token.saveUserProfile("CLIENT");
                    this.router.navigate(['main']);
                    this.showSuccess();
                }else{
                    this.token.removeToken()
                    this.showError();
                }
            }, 
            (err) => { 
                //toast.present();
                ///console.log("Erreur: ", err);
                this.showError();
            }

        ) ;
    }

    // For Toatr. 
    showSuccess() {
        this.toastr.success('Vous êtes connecté!', 'Connexion!');
      }

      // For Toatr. 
    showError() {
        this.toastr.error('Numéro souscripteur ou mot de passe incorrect!', 'Erreur de connexion!');
    }
}



// WEBPACK FOOTER //
// ./src/app/client-app/auth/auth.component.ts